<div class="fixed-top">
    <nav class="navbar">
        <div class="left-control">
            <a class="navbar-brand" href="/home"><img src="../../assets/images/bonds-logo.svg" alt="logo" /> </a>
            <div *ngIf="searchShow" class="form-inline custom-form ml-xl-5 ml-md-3 mr-3 d-none d-md-flex">
                <input type="text" name='search' class="form-control" placeholder="Search for Products, Brands & More"
                    maxLength="200" (keyup)="searchProduct($event)" [value]="searchText" (change)="changeValue($event)">
                <button *ngIf="searchText !== '' && searchText != null && searchText != undefined"
                    class="search-btn btn cross-btn" (click)="clearSearch()">
                    <img src="../../assets/images/cross.svg" alt="search" />
                </button>
                <button class="search-btn btn" type="button" (click)="applySearch(onGoingsearchValue)"><img
                        src="../../assets/images/search.svg" alt="search" /></button>
            </div>
            <div *ngIf="searchShow && !isMobile" class="select-width d-none d-md-flex">
                <select-address class="d-flex justify-content-end"></select-address>
            </div>
        </div>
        <div *ngIf="searchShow" class="right-controls ml-lg-4 ml-xl-0">
            <!-- For signed in user -->
            <div class="profile-info">
                <div class="btn-group" dropdown>
                    <button id="button-basic" dropdownToggle type="button" class="btn" aria-controls="dropdown-basic">
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                        aria-labelledby="button-basic">
                        <li class="user-name">
                            <span>Hi {{user.firstname}}!</span>
                        </li>
                        <li role="menuitem" *ngIf="hasUploadOrderFilePermissions">
                            <a title="Upload Order File" class="dropdown-item" [routerLink]="['/upload-order']">Upload Order File</a>
                        </li>
                        <li role="menuitem">
                            <a title="Change Password" class="dropdown-item"
                                routerLink="/profile/change-password">Change Password
                            </a>
                        </li>
                        
                        <li role="menuitem"><a title="Sign Out" class="dropdown-item" (click)="logout()"
                                href="javascript:void(0);">Logout</a></li>
                    </ul>
                </div>
            </div>
            <div class="cart ml-2 text-center" *ngIf="showCart" (click)="openMiniCart()">
                <span class="items">{{miniCartDetail.items_qty}}</span>
                <a href="javascript:void(0);"  class="number-item">
                    <img class="d-none d-md-block" src="../../assets/images/cart.svg" alt="cart" />
                    <img class="d-block d-md-none" src="../../assets/images/cart-mobile.svg" alt="cart" />

                    <p *ngIf="globalApiResponse.price_visibility == 0">items: {{miniCartDetail.items_count}}</p>
                    <p *ngIf="globalApiResponse.price_visibility == 1"><span>items:
                            {{miniCartDetail.items_count}}</span> <span>£{{miniCartDetail.subtotal}}
                        </span></p>
                </a>
            </div>

        </div>
        <div *ngIf="searchShow" class="bottom-control d-md-none d-flex mt-3">
            <div class="form-inline custom-form">
                <input type="text" name='search' class="search-field form-control" placeholder="Search" maxLength="200"
                    (keyup)="searchProduct($event)" [value]="searchText" (change)="changeValue($event)">
                <button *ngIf="searchText !== '' && searchText != null && searchText != undefined"
                    class="search-btn btn cross-btn" (click)="clearSearch()">
                    <img src="../../assets/images/cross.svg" alt="search" />
                </button>
                <button class="search-btn btn" type="button" (click)="applySearch(onGoingsearchValue)"><img
                        src="../../assets/images/search.svg" alt="search" /></button>
            </div>
        </div>
    </nav>
</div>
<div *ngIf="searchShow && isMobile" class="d-flex d-md-none col-12 white-select">
    <select-address></select-address>
</div>

<div class="mini-cart-main" *ngIf="miniCart">
    <div class="header-mini">
        <div class="left-header">
            <img src="../../../../assets/images/cart-basket.svg" width="34" alt="">
            <div class="my-basket-test">
            My Basket <span *ngIf="cartDetail">({{cartDetail?.total_qty}})</span>
            
          <div class="cases-basket" *ngIf="cartDetail.total_case == '1'"> {{cartDetail?.total_case}} Case</div>
                            <div class="cases-basket" *ngIf="cartDetail.total_case != '1'"> {{cartDetail?.total_case}} Cases</div>
           
        </div>
        </div>
        <div class="right-header">
            
            
            <a href="javascript:void(0);" (click)="closeMiniCart()"> <img class="closr-icon" src="../../../../assets/images/close.svg" alt=""></a>
            
        </div>
    </div>

    <div class="mini-cart-inner-main">

        <a class="remove-all-but" href="javascript:void(0);" *ngIf="productList.length != 0  && componentLoaded" (click)="removePopup(cartTemplate, 'All', '', '');">
            <img src="../../../../assets/images/basket-delete.svg" alt="">
        Remove All
        </a>
        <div class="text-box" *ngIf="productList.length > 0 && productList[0].recommendation_id > 0 && componentLoaded">
            <img src="../../../../assets/images/info-black.svg" alt="">
           <p class="m-0" > Some products below were added by <b>{{productList[0].sales_rep_name}}</b>,  go to basket for more info. </p>
        </div>
        <div class="mini-cart-box-main" *ngIf="miniCart && productList.length != 0  && componentLoaded">
            <div class="recommended-box" *ngFor="let product of productList">
                <span class="recommended" *ngIf="product.recommendation_id > 0">Recommended</span>

                <div class="left-box">
                    <div class="image-box">
                        <div class="left-image">
                            <a [routerLink]="['/product/detail',product.sku]" *ngIf="((is_retailer && !product?.is_srp_product) || !is_retailer)">
                                <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                            </a>
                            <a href="javascript:void(0);" *ngIf="product?.is_srp_product && is_retailer">
                                <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                            </a>
                          
                        </div>
                        <div class="right-contnet">
                            <div class="title"><span class="climp-css">{{product.short_desc}}</span> <span> {{product.unit_size}}</span>
                            </div>
                            <div class="small-div">
                                <div class="cost left" *ngIf="globalApiResponse?.price_visibility == 1">
                                    <span>Cost</span>
                                    <p><strong class="text-dark">£{{product.price}}</strong></p>
                                </div>
                                <div class="cost">
                                    <p>Case</p>
                                    <p><b>{{product.size_case}}</b></p>
                                </div>
                                <div class="cost left">
                                    <span>RSP</span>
                                    <p> <span class="text-dark" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                        <span class="text-dark" *ngIf="product.rsp == '0.00'">N/A</span>
                                        <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))" class="each">per 100g</span>
                                        <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)" class="each"> Each</span>
                                    </p>
                                </div>
                                
                                <div class="cost" *ngIf="globalApiResponse?.margin_visibility == 1">
                                    <p>Margin</p>
                                    <b class="text-dark">{{product.margin}}%</b>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="button-bottom">
                        <div class="bottom-inner-main">
                            <div class="left-column  col-md-6">
                                <span class="code-image">BC: {{product.barcode}}</span>
                            </div>
                            <div class="right-column suggested-col  col-md-4 p-0">
                                <div class="mt-2" id="spinner_{{product.product_id}}">
                                    <ngx-number-spinner *ngIf="((is_retailer && !product?.is_srp_product) || !is_retailer)" id="spinerbtn_{{product.product_id}}" [value]="product.item_qty !='' ? toInteger(product.item_qty) : 1" [min]="0" (change)="qytUpdate(product, $event, '', removeFromcartTemplate)">
                                    </ngx-number-spinner>
                                    <ngx-number-spinner *ngIf="product?.is_srp_product && is_retailer" class="disabled" id="spinerbtn_{{product.product_id}}" [value]="product.item_qty !='' ? toInteger(product.item_qty) : 1" [min]="0" (change)="qytUpdate(product, $event, '', removeFromcartTemplate)">
                                    </ngx-number-spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <a href="javascript:void(0);" (click)="removeItem(product, 'list');" title="Delete product">
                        <img src="../../../../assets/images/wos-bin-icon.svg" alt="">
                        
                    </a>
                    
                </div>
            </div>
        </div>

        <div class="main-bottom-minicart" *ngIf="miniCart && productList.length != 0  && componentLoaded">
            <div class="net-amout-box" *ngIf="globalApiResponse?.price_visibility == 1">
                <div class="net-amout">Net Amount</div>
                <div class="total">£{{cartDetail?.net_amount}}</div>
            </div>

            <div class="item-case-amin">


            <button class="go-to-basket" (click)="redirectTo()"> Go to Basket</button>
        </div>
    </div>
    <div class="main-mini-cart-empty" *ngIf="miniCart">
    
    <div class="mini-cart-empty" *ngIf="miniCart && productList.length == 0 && componentLoaded">
        <img src="../../../../assets/images/wos_cart_empty.svg" alt="">
        <h2>Basket is empty!</h2>
        <p>Shop for world class confectionery products on World of Sweets</p>
        <button class="continously-shoping" (click)="redirectToProductList()">Continue Shopping</button>
    </div>

    <div class="mini-cart-empty w-100" *ngIf="miniCart &&  !componentLoaded">
        <div class="col-12">
            <div class="no-result-content text-center">
                <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
                <p>Loading...</p>
            </div>
        </div>
    </div>
        
</div>
</div>

<ng-template #cartTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Confirmation!</h4>
        <button type="button" class="close  " aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fill-rule="evenodd">
              <g stroke="#9B9B9B" stroke-width="1.75">
                <g>
                  <g>
                    <path d="M14 0L0 14M0 0L14 14"
                      transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                  </g>
                </g>
              </g>
            </g>
          </svg></span>
      </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>{{removeHeading}}</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button ghost" *ngIf="removeType != ''" (click)="removeItem(removeProduct)">Confirm</button>
                    <button class="common-button ghost" *ngIf="removeType == ''" (click)="clearCart()">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #removeFromcartTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Confirmation!</h4>
        <button type="button" class="close  " aria-label="Close" (click)="cancleRequest(removeProduct)">
        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fill-rule="evenodd">
              <g stroke="#9B9B9B" stroke-width="1.75">
                <g>
                  <g>
                    <path d="M14 0L0 14M0 0L14 14"
                      transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                  </g>
                </g>
              </g>
            </g>
          </svg></span>
      </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Are you sure you want to remove product from cart?</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" (click)="cancleRequest(removeProduct)">Cancel</button>
        <button class="common-button ghost" (click)="removeItem(removeProduct)">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>